import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';
import Lottie from 'lottie-react';
import lottieAnimation from '../assets/lottie.json';
import { useNavigation } from '../context/NavigationContext';
import { telegramApp } from '../utils/telegram';
import { useTonConnectUI } from '@tonconnect/ui-react';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { showNavigation } = useNavigation();
  const [tasksCompleted, setTasksCompleted] = useState({
    publishStory: false,
    connectWallet: false,
  });
  const [tonConnectUI] = useTonConnectUI();

  const handleTaskComplete = (task: 'publishStory' | 'connectWallet') => {
    setTasksCompleted(prev => ({
      ...prev,
      [task]: true,
    }));
  };

  const handleConnectWallet = async () => {
    // Открываем попап TON Connect для привязки кошелька
    await tonConnectUI.openModal();
    handleTaskComplete('connectWallet');
  };

  const allTasksCompleted = tasksCompleted.publishStory && tasksCompleted.connectWallet;

  const handleForwardClick = () => {
    showNavigation();
    navigate('/mint');
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 3,
        }}
      >
        <Box 
          sx={{ 
            width: '100%',
            maxWidth: 300,
            height: 300,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
          }}
        >
          <Lottie 
            {...defaultOptions}
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0
            }}
          />
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={() => handleTaskComplete('publishStory')}
          sx={{ maxWidth: 300 }}
        >
          Опубликовать историю
        </Button>

        <Button
          variant="contained"
          fullWidth
          onClick={handleConnectWallet}
          sx={{ maxWidth: 300 }}
        >
          Подключить Telegram кошелёк
        </Button>

        {allTasksCompleted && (
          <Button
            variant="contained"
            fullWidth
            onClick={handleForwardClick}
            sx={{ maxWidth: 300, mt: 2 }}
          >
            Вперёд
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default HomePage; 